import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Box, ButtonBase, Typography } from "@mui/material";
import React from "react";
import { ArrowRight2px, Sizes } from "../icon/IconList";
const TextBanner = (param)=>{
    let { textBanner , subject  } = param;
    // mx-204
    const handleClick = (e)=>{
        e.preventDefault();
        mixpanelEvent("Text Banner Clicked", {
            Subject: subject,
            "Banner Text": textBanner.text,
            "Banner Url": textBanner.link
        }, {
            send_immediately: true
        }, ()=>{
            window.location.href = textBanner.link;
        });
    };
    return /*#__PURE__*/ _jsxs(ButtonBase, {
        onClick: handleClick,
        disableRipple: true,
        sx: {
            width: "100%",
            backgroundColor: textBanner.bgColors,
            px: {
                xs: 2.5,
                sm: 4
            },
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: {
                xs: "space-between",
                sm: "center"
            },
            gap: {
                xs: 0,
                sm: 0.5
            },
            "&:hover": {
                "& .banner-text": {
                    textDecoration: "underline"
                }
            }
        },
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle1",
                className: "banner-text",
                sx: {
                    color: "common.white",
                    textAlign: {
                        xs: "left",
                        sm: "center"
                    },
                    flex: {
                        xs: 1,
                        sm: "initial"
                    },
                    wordBreak: "keep-all"
                },
                children: textBanner.text
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ _jsx(ArrowRight2px, {
                    size: Sizes.small,
                    color: "#fff"
                })
            })
        ]
    });
};
export default TextBanner;
